module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('animated-fade-in', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    ref: "tabPanel",
    class: _vm.tabPaneClasses
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-348bcafa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/tab-pane.vue
// module id = 682
// module chunks = 85